import React from 'react';
import PropTypes from 'prop-types';
import LoanOfficersChatList from 'sharedComponents/LoanOfficersChatList';
import ChatPresenter from 'presenters/ChatPresenter';

import useStyles from './useStyles';

const ChatListPage = props => {
  const classes = useStyles();
  const { onChatSelect, chats, chatsInfo } = props;

  return (
    <div className={classes.paper}>
      <div className={classes.listContainer}>
        <LoanOfficersChatList chatsInfo={chatsInfo} onChatSelect={onChatSelect} chats={chats} />
      </div>
    </div>
  );
};

ChatListPage.propTypes = {
  chats: PropTypes.arrayOf(ChatPresenter.shape()).isRequired,
  onChatSelect: PropTypes.func.isRequired,
  chatsInfo: PropTypes.shape().isRequired,
};

export default ChatListPage;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/ChatListPage/ChatListPage.js